export const calculateMeshCountInsideObject = (obj) =>
  obj.children.reduce((acm, current) => {
    if (current.type === 'Mesh') {
      return acm + 1
    }
    if (current.type === 'Group') {
      return acm + calculateMeshCountInsideObject(current)
    }
    return acm
  }, 1)
